import {NovoAtendimento} from "./novo-atendimento";

export class AlteraAtendimento extends NovoAtendimento{
  id: number;
  ativo: boolean;
  dataCadastro: Date;
  descricaoResumida: string;
  status: number;
  solicitanteId: number;
}
